import { Circle, Marker, Pane, Tooltip, useMapEvents } from "react-leaflet";
import { OperationNames } from "Types/operation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import MapContainer from "Components/MapContainer";

import ArcAndShadow from "./paths/arcAndShadow";
import ArcAndShadow2 from "./inventoryPath/arcAndShadow";
import PathRoute from "./paths/route";
import LinePath from "./paths/line";
import Points from "./Points";
import Route from "./Route";
import Stations from "./Stations";
import MarkerClusterShow from "./clusters/MarkerClusterShow";
import Pointwise from "./Pointwise";
import Zones from "./Zones";
import HeatMap from "./heatMapGradian/heatmap";
import HeatMap2 from "./heatMap2";
import ContextMenu from "./contextMenu";
import ContextMenu2 from "./contextMenu2";
import AddSurvayLoc from "./addSurvayLoc";
import Streets from "./Streets";

function MapHandler() {
  const dispatch = useAppDispatch();

  const map = useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      const center = { lat, lng };
      const operationName: OperationNames[] = ["create-path", "edit-path"];
      // if (name !== null && operationName.includes(name)) dispatch(changeModal({ status: "add-station", data: { ...center } }));
    },
  });
  return <></>;
}

export default function Map() {
  const { surveyShowType, pointwiseShow, markerMode } = useAppSelector((state) => state.surveys);

  const { visibleType, singleSurvayData } = useAppSelector((state) => state.singleLocation);
  const { starDashboardVisible } = useAppSelector((state) => state.services);
  const { page } = useAppSelector((state) => state.page);

  const handleShowType = () => {
    if (surveyShowType === 0) {
      if (pointwiseShow) {
        return <Pointwise />;
      }
      return <MarkerClusterShow />;
    }
    if (surveyShowType === 1) {
      return <HeatMap />;
    }
    if (surveyShowType === 2) {
      return <HeatMap2 />;
    }
    return <></>;
  };

  return (
    <MapContainer>
      <MapHandler />
      <Streets />
      {starDashboardVisible ? null : (
        <>
          {" "}
          {/* <Route /> */}
          {/* <Points /> */}
        </>
      )}
      {page === 4 ? (
        <>
          <ArcAndShadow />
          <ArcAndShadow2 />
          <ContextMenu />
          <ContextMenu2 />
          {/* <PathRoute /> */}
          <LinePath />
          <Stations />
          <Zones />

          {handleShowType()}
          {visibleType === "survay" ? <Pointwise /> : null}
        </>
      ) : null}

      <AddSurvayLoc />
    </MapContainer>
  );
}
